import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { PlaybackArea } from '../../../shared/player/integration/playbackArea'
import { PlaybackContentLink } from '../../../shared/player'
import { DetailPageActions } from '../actions'
import { startPlayback } from '../actions/player'
import { IDetailPageState } from '../reducers'
import { playerConfigDataSelector } from '../selectors/player'

type PlaybackAreaProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

export const ConnectedPlaybackArea: React.StatelessComponent<
  PlaybackAreaProps
> = ({ startPlayback, pageContext, config, children }) => {
  return (
    <PlaybackArea
      pageType={config.pageType}
      onPlay={startPlayback}
      launchType={pageContext.playbackLaunchType}
      trailerLaunchType={pageContext.playbackTrailerLaunchType}>
      {children}
    </PlaybackArea>
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  pageContext: state.pageContext,
  config: playerConfigDataSelector(state),
})

const mapDispatchToProps = (dispatch: Dispatch<DetailPageActions>) => ({
  startPlayback: (playbackContentLink: PlaybackContentLink) =>
    dispatch(startPlayback(playbackContentLink)),
})

export const DPPlaybackArea = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedPlaybackArea)
